import * as _ from 'lodash';

export class LodashTemplateEvaluator {
  public static readonly cache = {};

  public static readonly templateSettings = {
    evaluate: /\{%([\s\S]+?)%\}/g,
    interpolate: /\{\{([\s\S]+?)\}\}/g, // NOSONAR
    escape: /\{\{\{([\s\S]+?)\}\}\}/g // NOSONAR
  };

  public static template(template, hash?): any {
    hash = hash || LodashTemplateEvaluator.stringHash(template);
    if (LodashTemplateEvaluator.cache[hash]) {
      return LodashTemplateEvaluator.cache[hash];
    }
    try {
      // Ensure we handle copied templates from the ejs files.
      const lodashTemplateSourceURL = '/lodash/template/source' + hash;
      const compiledTemplate = _.template(template, {
        ...LodashTemplateEvaluator.templateSettings,
        sourceURL: lodashTemplateSourceURL
      });

      LodashTemplateEvaluator.cache[hash] = compiledTemplate;

      return compiledTemplate;
    } catch (err) {
      console.warn('Error while processing template', err, template);
    }
  }

  public static interpolate(rawTemplate, data, hash?) {
    let template = LodashTemplateEvaluator.template(rawTemplate, hash);
    if (typeof template === 'function') {
      try {
        return template(data);
      } catch (err: any) {
        console.warn('Error interpolating template', err, rawTemplate, data);
        return rawTemplate;
      }
    }
    return template;
  }

  static stringHash(str) {
    //source -> https://www.npmjs.com/package/string-hash
    let hash = 5381,
      i = str.length;

    while (i) {
      hash = (hash * 33) ^ str.codePointAt(--i)!;
    }
    return hash >>> 0;
  }
}
